export default __webpack_public_path__ + "static/media/idr.64544d3f.png";